import {Component, OnInit} from '@angular/core';
import {GetFaqApiDataFormatted} from '../../../services/http-services/faq/faq-http-interfaces';
import {GrFaq} from '../../../interfaces/faq-interfaces';
import {GrPagination} from '../../../interfaces/general-interfaces';
import {FaqEnums} from '../../../enums/faq-enums';
import {FaqHttpService} from '../../../services/http-services/faq/faq-http.service';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {BannersHttpService} from '../../../services/http-services/banners/banners-http.service';
import {GrBanner} from '../../../interfaces/banners-interfaces';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EmailRegex} from '../../../constants/general-variables';
import {GeneralHttpService} from '../../../services/http-services/general/general-http.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-for-businesses',
  templateUrl: './for-businesses.component.html'
})
export class ForBusinessesComponent implements OnInit {
  faqs: GrFaq[] = [];
  activeFaqIndex = 0;
  banners: Record<string, GrBanner[]> = {};
  businessPartners = [0, 1, 2];
  urlParams: any = {type: FaqEnums.businessUserForDB, search: null};
  newsletterForm!: FormGroup;
  newsletterFormTriedToSubmit = false;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(private faqHttpService: FaqHttpService,
              private bannersHttpService: BannersHttpService,
              private generalHttpService: GeneralHttpService,
              private toastService: ToastrService,
              private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
    this.getBanners();
    this.getFaqs();
    this.buildForm();
  }

  buildForm(): void {
    this.newsletterForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(EmailRegex)]],
    });
  }

  getBanners(): void {
    this.bannersHttpService.getLandingWebBanners({bannerTypes: 'f'}).then(res => {
      this.banners = res.data;
    });
  }

  getFaqs(): void {
    this.faqHttpService.getLandingFaqs({page: 1, ...this.urlParams}).then((res: GetFaqApiDataFormatted) => {
      this.faqs = res.data;
      this.faqHttpService.getLandingFaqs({page: 2, ...this.urlParams}).then((secondRes: GetFaqApiDataFormatted) => {
        this.faqs = [...this.faqs, ...secondRes.data];
      });
    });
  }

  onSubmitPostNewsletterForm(): any {
    this.newsletterFormTriedToSubmit = true;
    if (this.newsletterForm.valid) {
      this.generalHttpService.postNewsletter(this.newsletterForm.value).then((res: any) => {
        this.toastService.success(res.message);
        this.newsletterFormTriedToSubmit = false;
        this.newsletterForm.reset();
      }).catch(error => {
        this.toastService.error(error.error.message);
      });
    }
  }
}
